import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { getHelpPageLink } from "../../store/config";
import { useIntlTranslate } from "../../hooks";
import { ExternalLink, useExternalLink } from "../externalLink/ExternalLink";
import { Icon } from "../icon";

export const useHelpLinkMenuItem = () => {
  const helpUrl = useSelector(getHelpPageLink);
  const [openExternalLink] = useExternalLink();

  return {
    id: "help_page",
    content: (
      <Fragment>
        <span>
          <FormattedMessage id={"help_page"} />
        </span>
        <Icon icon="fa-regular fa-square-up-right" />
      </Fragment>
    ),
    action: () => openExternalLink(helpUrl),
  };
};

export const HelpPageLink = ({ className, children }) => {
  const translate = useIntlTranslate();
  const helpUrl = useSelector(getHelpPageLink);

  return (
    <ExternalLink
      url={helpUrl}
      className={className}
      aria-label={translate("aria_external_link", {
        linkText: translate("aria_see_more_on_help"),
      })}
    >
      {children}
    </ExternalLink>
  );
};
